module.exports = __webpack_public_path__ + "static/media/Main-Page-1.763343fd.mp4";